/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError, AxiosResponse } from 'axios';

export interface ILoginBody {
  Email: string;
}
export interface ILoginVerificationBody {
  Email: string;
  Token: string; // otp
}
export interface ITokens {
  RefreshToken?: string;
  AccessToken?: string;
}

export type ISuccessResponse<T = any> = {
  total_stock?: number;
  data: T;
  status: number;
  message: string;
  pagecount?: number;
};

export type IErrorResponse<T = any> = {
  error?: T;
  data?: any;
  status: number;
  message?: string;
};

export interface IResponse {
  data?: string;
  status: number;
  message?: string;
}

export class ReliantResponse<T> {
  private _data?: T;
  private _status: number;
  private _error?: AxiosError;
  private _unwrapped: boolean = false;

  constructor(resp?: AxiosResponse<T>, error?: AxiosError) {
    if (error) {
      this._error = error;
      this._status = error.response?.status as number;
      return;
    }
    this._data = resp?.data;
    this._status = resp?.status as number;
  }

  check(): AxiosError | undefined {
    if (this._error) return this._error;
    if (this._status >= 300) {
      return new AxiosError(
        `unexpected code: ${this._status}`,
        `${this._status}`,
      );
    }
    this._unwrapped = true;
    return;
  }

  // You must check errors before access data
  unwrap(): T {
    if (!this._unwrapped) throw new Error('Response not checked');
    return this._data! as T;
  }
}
